import LemonError from '@src/service/common/LemonError';

export class InvalidEntityApiReturnValueException extends LemonError {
  constructor(action: string, reason: string) {
    super(`Invalid return value from entity API action "${action}": ${reason}`);
  }
}
